import React from "react";
import facebook from "./Images/Icons/facebook.png";
import twitter from "./Images/Icons/twitter.png";
import email from "./Images/Icons/email.png";
import phone from "./Images/Icons/call.png";



export const Topbar = props => {
  

  return (
    <div className="header d-flex justify-content-between align-items-center">
    <div className="contact-data">
      <a className="social-icons__link" href="tel:+48583501100">
        <img className="social-icons" src={phone} alt="phone" />
        <span className="social-icons__description">
          Telefon: +48 58 350 11 00
        </span>
      </a>
      <a
        className="social-icons__link"
        href="mailto: sekretariat@pkm-sa.pl"
      >
        <img className="social-icons" src={email} alt="email" />
        <span className="social-icons__description">
          Email: sekretariat@pkm-sa.pl
        </span>
      </a>
    </div>
    <div className="social-data">
      <a href="https://pl-pl.facebook.com/PomorskaKolejMetropolitalna/">
        <img
          className="social-icons"
          src={facebook}
          alt="facebook icon"
        />
      </a>
      <a href="https://twitter.com/pkmsagdansk">
        <img className="social-icons" src={twitter} alt="twitter logo" />
      </a>
    </div>
  </div>
  );
};
